<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent scrollable max-width="1200px">
      <v-card>
        <div class="dialog-header">
          <div class="popup-title">
            {{
              meeting && meeting.isLMSMeeting
                ? $t('page.meeting-control.lms-control')
                : $t('page.meeting-control.meeting-control')
            }}
          </div>
          <button
            @click="refreshAll"
            class="onlyIconButton ico_search"
            style="margin-right: 20px"
          >
            <img
              src="/static/icon-contents/reload1.svg"
              style="width: 16px; height: 16px"
            />
          </button>
        </div>
        <v-card>
          <v-card-text style="padding: 0 12px">
            <v-flex xs12 md12 v-if="meeting !== null">
              <v-container fluid grid-list-xl>
                <v-layout row wrap style="display: flex">
                  <div class="control-contents-wrap">
                    <div class="control-contents-row">
                      <span
                        >회의명 : {{ meeting.title }} ({{
                          meeting.coSpaceUri ? meeting.coSpaceUri : ''
                        }}번)</span
                      >
                    </div>
                    <div class="control-contents-row">
                      <span>회의 시간 :</span>
                      <span>
                        {{ meeting.startDtime | formatDate2 }} /
                        {{ meeting.startDtime | formatTime }} ~
                        {{ meeting.endDtime | formatTime }}
                      </span>
                    </div>
                    <div class="control-contents-row">
                      <span>비밀번호 :</span>
                      <span>{{
                        meeting.passcode ? meeting.passcode : `설정되지 않음`
                      }}</span>
                    </div>
                    <div class="control-contents-row">
                      <span>참여현황 :</span>
                      <span>참여2 / 미참여1</span>
                    </div>

                    <div class="control-contents-row">
                      <span>회의유형 :</span>
                      <span>{{
                        meeting.type === 'video' && meeting.callId
                          ? `HW전용`
                          : `PC&모바일`
                      }}</span>
                    </div>
                    <!-- <div>{{ (meeting.type === 'video' ? $t('page.statistics.all-status.video') : $t('page.statistics.all-status.room')) }}</div> -->
                    <div class="control-contents-row">
                      <span>주재자 :</span>
                      <span v-if="meeting.isInbound">
                        화상 기기 (수동 접속)
                      </span>
                      <span v-else>{{
                        meeting.creator.username
                          ? `${meeting.creator.username} (${
                              meeting.creator.deptName
                                ? meeting.creator.deptName
                                : '-'
                            })`
                          : ``
                      }}</span>
                    </div>
                    <div class="control-contents-row">
                      <span>부가서비스 :</span>
                      <span>{{ meeting.sttLog ? '실시간 번역' : '없음' }}</span>
                    </div>
                  </div>
                </v-layout>
              </v-container>
            </v-flex>
          </v-card-text>
        </v-card>

        <!-- <v-divider style="margin-top:-15px;"></v-divider> -->
        <v-card-actions id="meetingControl" style="padding: 0">
          <div
            class="meeting-control-btn"
            style="margin-left: 15px"
            @click="openMeetingLayoutDialog"
          >
            {{ `레이아웃 설정` }}
          </div>
          <div>
            <div
              class="meeting-control-btn"
              @click="setRecordStatus(!isRecording)"
            >
              {{ isRecording ? '녹화 종료' : '녹화 시작' }}
            </div>
            <!-- <div class="meeting-control-btn kb_bg" @click="muteAll">
              {{ `전체 음소거` }}
            </div> -->
            <!-- <div
              class="meeting-control-btn"
              style="font-size: 14px; background: red"
              v-if="!isManager"
              @click="finishMeeting"
            >
              {{ `회의 종료` }}
            </div> -->
            <!-- <div class="meeting-control-btn" @click="additionalInvite"> 
              {{ $t('page.meeting-control.invitation') }}
            </div> -->
          </div>
          <!-- <div class="meeting-control-btn" @click="refreshAll">
            {{ $t('page.meeting-control.refresh') }}
          </div> -->

          <!-- <v-btn class="btn-round" color="secondary" dark text round @click="fixLayoutClick">
            <v-icon color="white">mdi-plus-box-outline</v-icon>{{ $t('page.meeting-control.fixed-layout') }}
          </v-btn>
          <v-btn class="btn-round" color="secondary" dark text round @click="setRecordStatus(!isRecording)">
            <v-icon color="white" large>mdi-record-rec</v-icon>{{ isRecording ? '녹화 종료': '녹화 시작' }}
          </v-btn>
          <v-btn class="btn-round" color="secondary" dark text round @click="dialAll">
            <v-icon color="white">mdi-phone-forward</v-icon>{{ $t('page.meeting-control.all-connection') }}
          </v-btn>
          <v-btn class="btn-round" color="secondary" dark text round @click="muteAll">
            <v-icon color="white">mdi-volume-mute</v-icon>{{ $t('page.meeting-control.all-mute') }}
          </v-btn>
          <v-btn class="btn-round" color="secondary" dark text round @click="additionalInvite">
            <v-icon color="white">add</v-icon>{{ $t('page.meeting-control.invitation') }}
          </v-btn>
          <v-btn class="btn-round" color="secondary" dark text round @click="refreshAll">
            <v-icon color="white">refresh</v-icon>{{ $t('page.meeting-control.refresh') }}
          </v-btn> -->
        </v-card-actions>
        <div class="tbw_tb01 dataTable detail" style="padding: 5px">
          <div
            style="
              display: flex;
              flex-direction: row;
              justify-content: space-between;
            "
          >
            <div style="display: flex; gap: 10px">
              <div
                class="history-info-btn"
                @click="changeActive('all')"
                :class="active === 'all' ? 'history-info-btn-active' : ''"
              >
                전체
              </div>
              <div
                class="history-info-btn"
                @click="changeActive('codec')"
                :class="active === 'codec' ? 'history-info-btn-active' : ''"
              >
                화상기기
              </div>
              <div
                class="history-info-btn"
                @click="changeActive('attendee')"
                :class="active === 'attendee' ? 'history-info-btn-active' : ''"
              >
                사용자
              </div>
            </div>
          </div>
        </div>
        <v-card-text>
          <v-card>
            <v-data-table
              :headers="getHeaders()"
              :items="attendeeList"
              :loading="loading"
              :rows-per-page-items="[8, 10, 20, 50]"
            >
              <template v-slot:headers="props">
                <tr style="height: 45px !important">
                  <th
                    v-for="header in props.headers"
                    :key="header.text"
                    :class="['header-text-popup', 'column']"
                    :style="header.width ? 'width:' + header.width + ';' : ''"
                  >
                    <!-- <v-icon small>arrow_upward</v-icon> -->
                    {{ header.text }}
                  </th>
                </tr>
              </template>
              <template slot="items" slot-scope="props">
                <td class="text-xs-center">
                  {{
                    props.item.type === 'pc'
                      ? 'PC'
                      : props.item.type === 'mobile'
                      ? '모바일'
                      : props.item.type === 'codec'
                      ? '화상기기'
                      : '-'
                  }}
                </td>
                <!-- <td class="text-xs-center">{{ getTypeString(props.item.participantType, props.item.type) }}</td> -->
                <!-- <td class="text-xs-center">{{ props.item.invited
                  ? $t('page.meeting-control.attendee-list.inviter')
                  : $t('page.meeting-control.attendee-list.non-inviter') }}</td> -->
                <td class="text-xs-center">{{ props.item.name }}</td>
                <td class="text-xs-center">
                  <div class="state-btn">
                    {{ props.item.status === true ? '참여' : '미참여' }}
                  </div>
                  <!-- <v-sheet label small :color="(props.item.status === true) ? 'green': 'red'" style="color: white; min-width: 90px; max-width: 90px; height: 25px; padding-top: 2px;" >
                    {{ (props.item.status === true)
                        ? $t('page.meeting-control.attendee-list.on-line')
                        : $t('page.meeting-control.attendee-list.off-line') }}
                  </v-sheet> -->
                </td>
                <td class="text-xs-center">
                  <v-icon
                    color="primary"
                    @click="
                      loading = true;
                      props.item['connLoading'] = true;
                      changeAudioStatus(props.item);
                    "
                    :disabled="
                      props.item.status &&
                      !(
                        props.item.type === 'codec' &&
                        props.item.rxAudioMute === true
                      )
                        ? false
                        : true
                    "
                  >
                    {{
                      !props.item.rxAudioMute
                        ? 'mdi-microphone'
                        : 'mdi-microphone-off'
                    }}
                  </v-icon>
                </td>
                <td class="text-xs-center">
                  <v-icon
                    color="primary"
                    @click="
                      loading = true;
                      props.item['connLoading'] = true;
                      changeVideoStatus(props.item);
                    "
                    :disabled="props.item.status ? false : true"
                  >
                    {{
                      !props.item.rxVideoMute ? 'mdi-video' : 'mdi-video-off'
                    }}
                  </v-icon>
                </td>
                <td class="text-xs-center">
                  <v-icon
                    color="primary"
                    @click="
                      // loading = true;
                      // props.item['connLoading'] = true;
                      connectUser(
                        props.item.remoteParty,
                        props.item.name,
                        props.item,
                      )
                    "
                    :disabled="
                      props.item.status || props.item.connLoading ? true : false
                    "
                    >mdi-login</v-icon
                  >
                </td>
                <td class="text-xs-center">
                  <v-icon
                    color="primary"
                    @click="
                      disConnectUser(
                        props.item.callLegId,
                        props.item.serverIdx,
                        props.item.type,
                        props.item,
                      )
                    "
                    :disabled="props.item.status ? false : true"
                    >mdi-logout</v-icon
                  >
                </td>
                <!-- <td class="text-xs-center">
                  <v-select
                    height="32px"
                    style="margin-top: 3px"
                    :items="layoutList"
                    v-model="props.item.chosenLayout"
                    @change="
                      layoutChange(
                        props.item.callLegId,
                        props.item.chosenLayout
                      )
                    "
                    hide-details
                    outline
                    color="pink"
                    solo
                    class="layout-selector"
                  >
                    <template v-slot:selection="{ item }">
                      <span style="font-size: 11px">{{ item.text }}</span>
                    </template>
                    <template slot="item" slot-scope="data">
                      <template>
                        <img
                          v-bind:src="data.item.url"
                          style="width: 18px; height: 18px"
                          :alt="data.item.text"
                        />&nbsp;
                        <span>{{ data.item.text }}</span>
                      </template>
                    </template>
                  </v-select>
                </td> -->
                <td class="text-xs-center">
                  <v-icon
                    color="primary"
                    @click="attendeeDetailClick(props.item)"
                    :disabled="props.item.status ? false : true"
                    >mdi-information-outline</v-icon
                  >
                  <!-- :disabled="props.item.status ? false : true" -->
                </td>
              </template>
            </v-data-table>
          </v-card>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
        </v-card-actions>
        <div class="btnArea">
          <button class="btnPrimary" @click="popupClose">닫기</button>
        </div>
      </v-card>
    </v-dialog>
    <loading-dialog
      :dialog="loadingDialog.dialog"
      :content="loadingDialog.content"
    />
    <warning-dialog
      :title="warning.title"
      :content="warning.content"
      :confirmText="warning.confirmText"
      :dialog="warning.dialog"
      :closeDialog="closeWarningDialog"
      :message="warning.errorMsg"
    />
    <!-- <meeting-additional-invite-dialog
      :dialog="addRoom.dialog"
      :meetingInfo="meeting ? meeting : {}"
      :roomItems="addRoom.roomItems"
      :roomSave="roomSave"
      :organizationItems="addAttendee.organizationItems"
      :people="addAttendee.people"
      :closeDialog="closeRoomDialog"
    /> -->
    <meeting-attendee-detail-dialog
      :dialog="attendeeDetail.dialog"
      :attendeeInfo="attendeeDetail.attendeeInfo"
      :attendeeDetailInfo="attendeeDetail.attendeeDetailInfo"
      :refreshDetailData="refreshDetailData"
      :layoutList="layoutList"
      :layoutChange="layoutChange"
      :closeDialog="closeDetailDialog"
    />
    <!-- <meeting-conference-dialog
      :dialog="meetingConferenceDialog.dialog"
      :closeDialog="closeMeetingConferenceDialog"
      :rooms="meetingConferenceDialog.rooms"
      :selectedRooms="[]"
      :meetingInfo="meetingConferenceDialog.meetingInfo"
      @roomSave="roomSave"
    />
    <organization-chart-dialog
      :dialog="organizationChartDialog.dialog"
      :meetingId="organizationChartDialog.meetingId"
      :selectedAttendees="[]"
      :closeDialog="closeUserInvitationDialog"
      @attendeeSave="attendeeSave"
    /> -->
    <meeting-layout-dialog
      :dialog="meetingLayoutDialog.dialog"
      :attendees="meetingLayoutDialog.attendees"
      :meeetingFixSeatList="meetingLayoutDialog.fixSeatList"
      :selectLayoutCode="meetingLayoutDialog.selectedLayoutCode"
      :conferenceRoomActive="meetingInfo.conferenceRoomActive"
      @selectedFixSeatList="selectedFixSeatList"
      @closeMeetingLayoutDialog="closeMeetingLayoutDialog"
    />
  </v-layout>
</template>
<script>
import Util from '@/util';
import WarningDialog from '@/components/popup/WarningDialog';
import LoadingDialog from '@/components/popup/LoadingDialog';
// import MeetingAdditionalInviteDialog from '@/components/popup/MeetingAdditionalInviteDialog';
import MeetingAttendeeDetailDialog from '@/components/popup/MeetingAttendeeDetailDialog';
// import MeetingConferenceDialog from '@/components/popup/MeetingConferenceDialog';
// import OrganizationChartDialog from '@/components/popup/organizationChartDialog';
import MeetingLayoutDialog from '@/components/popup/MeetingLayoutDialog';
import moment from 'moment';
import timezone from 'moment-timezone';
import API from '@/api';

export default {
  components: {
    LoadingDialog,
    WarningDialog,
    MeetingLayoutDialog,
    // MeetingAdditionalInviteDialog,
    MeetingAttendeeDetailDialog,
    // MeetingConferenceDialog,
    // OrganizationChartDialog,
  },
  props: ['meeting', 'dialog', 'closeDialog', 'isManager', 'conferenceRooms'],
  data() {
    return {
      active: 'all',
      meetingInfo: {},
      attendeeList: [],
      deviceList: [],
      messageText: '',
      selectedMessageTime: 'permanent',
      messageTimeList: [
        { value: 'permanent', text: '유지' },
        { value: '60', text: '1분' },
        { value: '120', text: '2분' },
        { value: '600', text: '10분' },
      ],
      isRecording: false,
      isStreaming: false,
      layoutAll: API.layoutList[0],
      loading: false,
      loadingDialog: {
        dialog: false,
        content: '',
      },
      /*
       * 경고 Dialog
       */
      warning: {
        title: '',
        content: '',
        confirmText: '',
        type: '',
        dialog: false,
        errorMsg: null,
      },

      /*
       * 회의실 추가 초대 Dialog
       */
      // addRoom: {
      //   dialog: false,
      //   roomItems: [],
      //   personalItems: [],
      // },
      /*
       * 개인 단말 추가 초대 Dialog
       */
      addAttendee: {
        dialog: false,
        organizationItems: [],
        people: [],
      },
      /*
       * 참여자 상세정보 Dialog
       */
      attendeeDetail: {
        dialog: false,
        attendeeInfo: {},
        attendeeDetailInfo: null,
      },
      /**
       * 레이아웃 Dialog
       */
      meetingLayoutDialog: {
        dialog: false,
        attendees: [],
        fixSeatList: [],
        selectedLayoutCode: null,
      },
      /** 회의실 Dialog */
      meetingConferenceDialog: {
        dialog: false,
        rooms: [],
        selectedRooms: [], // 조직도 Dialog Open 시 이미 선택된 리스트 바인딩을 위한 값.
      },
      /*
       * 추가 초대 Dialog
       */
      organizationChartDialog: {
        dialog: false,
        selectedAttendees: [], // 조직도 Dialog Open 시 이미 선택된 리스트 바인딩을 위한 값.
      },
      layoutList: API.layoutList,
      /*
       * 레이아웃 고정 Dialog
       */
      fixLayout: {
        dialog: false,
      },

      isRecordShow: false,
      isStreamingShow: true,
      call: null,
    };
  },
  computed: {
    computePageHeaderIcon() {
      return '/static/page_header.png';
    },
  },
  watch: {
    async dialog(val) {
      if (!val) return;
      this.isRecordShow = this.$route.name === 'DashboardSimple';
      this.isStreamingShow = this.$route.name === 'DashboardSimple';
      this.meetingInfo = this.meeting;
      this.attendeeList = [];
      this.loadingDialog.dialog = true;
      this.active = 'all';
      // 참여자 정보 가져오기
      this.initAttendees(this.meetingInfo);
      // this.getCoSpaceInfo(this.meetingInfo.callId, this.meetingInfo._id);
      await Promise.all([
        this.getCoSpaceInfo(this.meetingInfo.callId, this.meetingInfo._id),
        this.getControlDevice(this.meetingInfo._id),
        this.getCallStatus(this.meetingInfo.callId, this.meetingInfo._id),
        this.getNowStatus(this.meetingInfo.callId),
        this.getNowStatusFromSaeha(this.meetingInfo._id),
      ]);
      this.attendeeListSort();
      this.loadingDialog.dialog = false;
    },
  },
  methods: {
    async getMeetingInfo() {
      const meetingData = (
        await this.$http.get(`/api/v1/meetings/info/${this.meetingInfo._id}`)
      ).data;
      this.meetingInfo = meetingData;
    },
    async changeActive(type) {
      this.active = type;
      await this.refreshAll();
      console.log('changeActive called', {
        attendeeList: this.attendeeList,
        type,
      });
      if (this.active === 'all') {
        return;
      } else if (this.active === 'codec') {
        this.attendeeList = this.attendeeList.filter((attendee) => {
          return attendee['type'] === 'codec';
        });
        console.log('codec filter', { attendeeList: this.attendeeList });
      } else {
        this.attendeeList = this.attendeeList.filter((attendee) => {
          return (
            attendee['type'] === 'pc' ||
            attendee['type'] === 'mobile' ||
            attendee['type'] === '-'
          );
        });
        console.log('attendee filter', { attendeeList: this.attendeeList });
      }
    },
    async openMeetingRoomDialog() {
      alert(
        `${this.meetingInfo.coSpaceUri} 번 방으로 접속 하도록 안내 해주시기 바랍니다.`,
      );
      console.log(`openMeetingRoomDialog called..`);
      this.meetingConferenceDialog.rooms = await this.getRooms();
      this.meetingConferenceDialog.selectedRooms = Object.assign(
        [],
        this.meetingInfo.deviceIds,
      );
      this.meetingConferenceDialog.meetingInfo = {
        startDtime: this.meetingInfo.startDtime,
        endDtime: this.meetingInfo.endDtime,
        _id: this.meetingInfo._id,
      };

      this.meetingConferenceDialog.dialog = true;
    },
    async getRooms() {
      let rooms = null;
      try {
        let start = moment.tz(
          this.meetingInfo.reservedDate + ' ' + this.meetingInfo.startTime,
          this.meetingInfo.timeZone,
        );
        let end = moment.tz(
          this.meetingInfo.reservedDate + ' ' + this.meetingInfo.endTime,
          this.meetingInfo.timeZone,
        );
        console.log(start, end);

        let params = {
          _id: this.meetingInfo._id,
          startDtime: start.utc().format('YYYY-MM-DDTHH:mm:ss') + 'Z',
          endDtime: end.utc().format('YYYY-MM-DDTHH:mm:ss') + 'Z',
        };
        rooms = (
          await this.$http.get('/api/v1/devices/revStatus', { params: params })
        ).data;
        console.log('getRooms called..', { rooms });
      } catch (error) {
        console.log('getRooms() Error', { error });
      }
      return rooms;
    },
    closeMeetingConferenceDialog() {
      this.meetingConferenceDialog.dialog = false;
    },
    openUserInvitationDialog() {
      console.log('openUserInvitationDialog called..');
      this.organizationChartDialog.dialog = true;
    },
    async closeUserInvitationDialog() {
      console.log('closeUserInvitationDialog called..');
      this.organizationChartDialog.dialog = false;
    },
    async attendeeSave(selectedAttendees) {
      console.log(`attendeeSave called.. `, { selectedAttendees });
      let params = {
        attendees: selectedAttendees,
      };

      try {
        let response = (
          await this.$http.post(
            `/api/v1/meetings/${this.meetingInfo._id}/attendees`,
            params,
          )
        ).data;
        console.log('attendeeSave called.. ', { response });

        this.meetingInfo = response;

        this.initAttendees(this.meetingInfo);
        this.getCoSpaceInfo(this.meetingInfo.callId, this.meetingInfo._id);
        await Promise.all([
          this.getControlDevice(this.meetingInfo._id),
          this.getCallStatus(this.meetingInfo.callId, this.meetingInfo._id),
          this.getNowStatus(this.meetingInfo.callId),
          this.getNowStatusFromSaeha(this.meetingInfo._id),
        ]);
        // await this.getControlDevice(this.meetingInfo._id);
        // await this.getCallStatus(this.meetingInfo.callId, this.meetingInfo._id);
        // await this.getNowStatus(this.meetingInfo.callId);
        // await this.getNowStatusFromSaeha(this.meetingInfo._id);
        this.attendeeListSort();
        this.organizationChartDialog.dialog = false;
      } catch (err) {
        console.log(err);
      }
    },
    getHeaders() {
      return [
        {
          text: '참여유형',
          value: 'type',
          align: 'center',
          width: '120px',
          sortable: false,
          class: 'header-text-popup',
        },
        // { text: this.$t('page.meeting-control.attendee-list.participant-type'), value: 'participantType', align: 'center', width: '150px', sortable: false, class: 'header-text-popup' },
        // { text: this.$t('page.meeting-control.attendee-list.invited'), value: 'invited', width: '110px', align: 'center', sortable: false, class: 'header-text-popup' },
        {
          text: '참여자',
          value: 'name',
          align: 'center',
          sortable: false,
          class: 'header-text-popup',
        },
        {
          text: '상태',
          width: '100px',
          value: 'status',
          align: 'center',
          sortable: false,
          class: 'header-text-popup',
        },
        // { text: this.$t('page.meeting-control.attendee-list.ip'), value: 'ip', width: '160px', align: 'center', sortable: false, class: 'header-text-popup' },
        {
          text: '마이크',
          value: 'rxAudioMute',
          width: '70px',
          align: 'center',
          sortable: false,
          class: 'header-text-popup',
        },
        {
          text: '카메라',
          value: 'rxVideoMute',
          width: '70px',
          align: 'center',
          sortable: false,
          class: 'header-text-popup',
        },
        {
          text: '연결',
          value: 'connection',
          width: '70px',
          align: 'center',
          sortable: false,
          class: 'header-text-popup',
        },
        {
          text: '끊기',
          value: 'hangUp',
          width: '70px',
          align: 'center',
          sortable: false,
          class: 'header-text-popup',
        },
        // {
        //   text: '문서공유',
        //   value: 'share',
        //   width: '70px',
        //   align: 'center',
        //   sortable: false,
        //   class: 'header-text-popup',
        // },
        // {
        //   text: '레이아웃',
        //   value: 'layout',
        //   width: '220px',
        //   align: 'center',
        //   sortable: false,
        //   class: 'header-text-popup',
        // },
        // { text: this.$t('page.meeting-control.attendee-list.layout'), value: 'layout', width: '80px', align: 'center', sortable: false, class: 'header-text-popup' },
        {
          text: '세부정보',
          value: 'detail',
          width: '70px',
          align: 'center',
          sortable: false,
          class: 'header-text-popup',
        },
      ];
    },
    initAttendees(meeting) {
      console.log('initAttendees called..', { meeting });
      this.attendeeList = meeting.attendees.map((item) => {
        return {
          type: '-',
          invited: true,
          userId: item.empNum,
          name: `${item.name}${item.title ? `/${item.title}` : ''}${
            item.companyName ? `/${item.companyName}` : ''
          }`, // item.displayFullName,
          remoteParty: item.empNum ? item.empNum : item.email,
          status: false,
          callLegId: null,
        };
      });
      console.log('initAttendees called..', {
        attendeeList: this.attendeeList,
      });
    },
    async getControlDevice(meetingId) {
      await this.$http
        .get('/api/v1/meetings/getControlDevice', {
          params: { _id: meetingId },
        })
        .then((response) => {
          let deviceData = response.data.map((item) => {
            return {
              type: 'codec',
              invited: true,
              userId: null,
              name: item.deviceName,
              remoteParty: item.uri,
              status: false,
              callLegId: null,
            };
          });
          this.attendeeList = this.attendeeList.concat(deviceData);
          console.log('getControlDevice called..', {
            response,
            attendeeList: this.attendeeList,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async getCoSpaceInfo(callId, meetingId) {
      try {
        let response = await this.$http.get('/api/v1/meetings/getCoSpaceInfo', {
          params: { callId: callId, meetingId: meetingId },
        });

        let coSpaceInfo = response.data.coSpace;
        console.log('getCoSpaceInfo called..', { coSpaceInfo });
        if (coSpaceInfo && coSpaceInfo.defaultLayout) {
          this.layoutAll = coSpaceInfo.defaultLayout;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getCallStatus(callId, meetingId) {
      await this.$http
        .get('/api/v1/meetings/getCallStatus', {
          params: { callId: callId, meetingId: meetingId },
        })
        .then((response) => {
          this.call = response.data;
          console.log(`this.call.call`, this.call.call);
          this.isRecording =
            this.call.call.recording === 'true' ||
            this.call.call.recording === true
              ? true
              : false;
          this.isStreaming =
            this.call.call.streaming === 'true' ||
            this.call.call.streaming === true
              ? true
              : false;
          console.log(
            `isRecording/ isStreaming`,
            this.isRecording,
            this.isStreaming,
          );
          console.log(this.call);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getStatusFromCd(statusCd) {
      // 마이크 상태값 셋팅
      if (statusCd === 1) {
        // ON
        return false;
      } else if (statusCd === 2) {
        // OFF
        return true;
      } else {
        return false;
      }
    },
    async getNowStatus(callId) {
      try {
        let response = await this.$http.get('/api/v1/meetings/getNowStatus', {
          params: { callId: callId },
        });

        // 데이터 매핑하기
        if (response.data.callLegs === undefined) {
          this.attendeeListSort();
          this.loadingDialog.dialog = false;
          return;
        }
        if (Number(response.data.callLegs.$.total) >= 1) {
          let callLegs = [];
          if (!Array.isArray(response.data.callLegs.callLeg)) {
            callLegs.push(response.data.callLegs.callLeg);
          } else {
            callLegs = response.data.callLegs.callLeg;
          }
          callLegs.forEach((item) => {
            if (item.participantType === 'codec') {
              const index = this.attendeeList.findIndex(
                (elem) =>
                  elem.remoteParty === item.remoteParty ||
                  elem.remoteParty === item.remoteParty.split('@')[0],
              );
              // 초대자
              if (index >= 0) {
                this.attendeeList[index]['callLegId'] = item.$.id;
                this.attendeeList[index]['status'] = true;
                if (item.participantType === 'webex') {
                  this.attendeeList[index].type = 'webex';
                }
                this.attendeeList[index]['participantType'] =
                  item.participantType;
                this.attendeeList[index]['rxAudioMute'] = item.rxAudioMute;
                this.attendeeList[index]['rxVideoMute'] = item.rxVideoMute;
                this.attendeeList[index]['serverIdx'] = item.serverIdx;
                this.attendeeList[index]['presentationContributionAllowed'] =
                  item.presentationContributionAllowed;
                this.attendeeList[index]['chosenLayout'] = item.chosenLayout
                  ? item.chosenLayout
                  : this.layoutAll;
                this.attendeeList[index]['type'] = item.participantType;
              } else {
                let checkName = item.name ? item.name : item.remoteParty;
                if (!['streaming', 'recording'].includes(checkName)) {
                  // 비 초대자
                  let type = 'person';
                  if (
                    (item.remoteParty.split('@').length >= 1 &&
                      Util.validationIpAddress(
                        item.remoteParty.split('@')[1],
                      ) === true) ||
                    item.participantType === 'codec'
                  ) {
                    type = 'codec';
                  }
                  this.attendeeList.push({
                    type: item.participantType,
                    invited: false,
                    name: item.name ? item.name : item.remoteParty,
                    remoteParty: item.remoteParty,
                    status: true,
                    callLegId: item.$.id,
                    participantType: item.participantType,
                    rxAudioMute: item.rxAudioMute,
                    rxVideoMute: item.rxVideoMute,
                    serverIdx: item.serverIdx,
                    presentationContributionAllowed:
                      item.presentationContributionAllowed,
                    chosenLayout: item.chosenLayout
                      ? item.chosenLayout
                      : this.layoutAll,
                  });
                }
              }
            } else {
              const index = this.attendeeList.findIndex(
                (elem) =>
                  elem.remoteParty === item.remoteParty ||
                  elem.remoteParty === item.remoteParty.split('@')[0],
              );
              // 초대자
              if (index >= 0) {
                this.attendeeList[index]['callLegId'] = item.$.id;
                this.attendeeList[index]['chosenLayout'] = item.chosenLayout
                  ? item.chosenLayout
                  : this.layoutAll;
              }
            }
          });
        }

        console.log('getNowStatus called..', {
          response,
          attendeeList: this.attendeeList,
        });
      } catch (error) {
        console.log(error);
        this.loadingDialog.dialog = false;
      }
    },
    async getNowStatusFromSaeha(meetingKey) {
      try {
        let response = await this.$http.get(
          '/api/v1/meetings/pcmobile/participants',
          {
            params: { meetingKey, isMCU: true },
          },
        );

        // 사용자 정보 매핑
        if (!response.data.data) {
          console.log('getNowStatusFromSaeha called..', {
            response,
            attendeeList: this.attendeeList,
          });
          this.loadingDialog.dialog = false;
          return;
        }
        let participants = response.data.data.content;
        participants.forEach((item) => {
          const index = this.attendeeList.findIndex(
            (elem) => elem.userId === item.userId,
          );
          // 초대자
          if (index >= 0) {
            // 참여자 셋팅
            this.attendeeList[index]['name'] = item.userName;

            // 참여유형 셋팅
            if ([3, 4, 5, 6].includes(item.clientType)) {
              this.attendeeList[index]['type'] = 'mobile';
            } else if (item.clientType === 11) {
              this.attendeeList[index]['type'] = 'codec';
            } else {
              this.attendeeList[index]['type'] = 'pc';
            }

            // 상태 셋팅
            this.attendeeList[index]['status'] = true;
            // 마이크 상태값 셋팅
            this.attendeeList[index]['rxAudioMute'] = this.getStatusFromCd(
              item.micStatusCd,
            );
            // 카메라 상태값 셋팅
            this.attendeeList[index]['rxVideoMute'] = this.getStatusFromCd(
              item.camStatusCd,
            );

            this.attendeeList[index]['meetCode'] = item.meetCode;
            this.attendeeList[index]['roomCode'] = item.roomCode;
            // this.attendeeList[index]['presentationContributionAllowed'] =
            //   item.presentationContributionAllowed;
            // this.attendeeList[index]['chosenLayout'] = item.chosenLayout
            //   ? item.chosenLayout
            //   : this.layoutAll;
            // this.attendeeList[index]['type'] = item.participantType;
          } else {
            // 비 초대자
            // 참여자 셋팅
            let type = '-';
            // 참여유형 셋팅
            if ([3, 4, 5, 6].includes(item.clientType)) {
              type = 'mobile';
            } else if (item.clientType === 11) {
              type = 'codec';
            } else {
              type = 'pc';
            }

            this.attendeeList.push({
              type: type,
              invited: false,
              name: item.userName,
              remoteParty: item.userId,
              userId: item.userId,
              status: true,
              participantType: item.participantType,
              rxAudioMute: this.getStatusFromCd(item.micStatusCd),
              rxVideoMute: this.getStatusFromCd(item.camStatusCd),
              // presentationContributionAllowed:
              //   item.presentationContributionAllowed,
              // chosenLayout: item.chosenLayout
              //   ? item.chosenLayout
              //   : this.layoutAll,
            });
          }
        });
        console.log('getNowStatusFromSaeha called..', {
          response,
          attendeeList: this.attendeeList,
        });
      } catch (error) {
        console.log(error);
        this.loadingDialog.dialog = false;
      }
    },
    async attendeeListSort() {
      // !!this.attendeeList Sort!! ( 정렬 순서 변경 필요할 수 있음 )
      console.log(`attendeeListSort Start`);
      this.attendeeList.sort((a, b) => {
        let o1 = String(a.type).toLowerCase();
        let o2 = String(b.type).toLowerCase();

        let p1 = String(a.status).toLowerCase();
        let p2 = String(b.status).toLowerCase();

        if (p1 < p2) return 1;
        if (p1 > p2) return -1;
        if (o1 < o2) return 1;
        if (o1 > o2) return -1;

        return 0;
      });
    },
    async updateUserStatus(callLegId, type) {
      return new Promise(async (resolve, reject) => {
        /**
         * @type Audio Mute, Unmute - { "rxAudioMute": true, false }
         * @type Video Mute, Unmute - { "rxVideoMute": true, false }
         * @type Set Layout - { "chosenLayout": layoutList selected value }
         */

        console.log('updateUserStatus called..', { type });
        await this.$http
          .post(`/api/v1/meetings/updateUserStatus/${callLegId}`, type)
          .then((response) => {
            console.log(response);
            resolve(true);
          })
          .catch((error) => {
            console.log(error);
            resolve(false);
          });
      });
    },
    async updateUserStatusAll(type) {
      /**
       * @type Audio Mute, Unmute - { "rxAudioMute": true, false }
       * @type Video Mute, Unmute - { "rxVideoMute": true, false }
       * @type Set Layout - { "layout": layoutList selected value }
       */
      let callId = this.meetingInfo.callId;
      if (callId === '' && this.meetingInfo.callId2 !== '') {
        callId = this.meetingInfo.callId2;
      } else if (callId === '' && this.meetingInfo.callId3 !== '') {
        callId = this.meetingInfo.callId3;
      }

      console.log('updateUserStatusAll called..', { callId });

      await this.$http
        .post(`/api/v1/meetings/updateUserStatusAll/${callId}`, type)
        .then((response) => {
          // console.log(response);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async changeAudioStatus(item) {
      if (item.type === 'codec') {
        // CMS 제어
        this.loadingDialog.dialog = true;
        await this.updateUserStatus(item.callLegId, {
          rxAudioMute: !item.rxAudioMute,
          callId: this.meetingInfo.callId,
          serverIdx: item.serverIdx,
        });
        await this.updateCallLegIdStatus(
          item.callLegId,
          item.remoteParty,
          item.serverIdx,
        );
        this.loadingDialog.dialog = false;
      } else {
        // 새하 제어
        let type = 2; // (CAM: 1, MIC: 2, SPK: 3)
        let value = item.rxAudioMute ? 1 : 0; // (STOP: 0, START: 1)
        this.loadingDialog.dialog = true;
        await this.updateParticipantDevice(
          this.meetingInfo._id,
          item.userId,
          type,
          value,
        );
        console.log('changeAudioStatus called..', { item });
        setTimeout(async () => {
          await this.refreshParticipantsStatus(item.roomCode, item.userId);
          this.loading = false;
        }, 500);
      }
    },
    async changeVideoStatus(item) {
      console.log('changeVideoStatus called..', {
        item,
      });

      if (item.type === 'codec') {
        // CMS 제어
        this.loadingDialog.dialog = true;
        let lod1 = await this.updateUserStatus(item.callLegId, {
          rxVideoMute: !item.rxVideoMute,
          callId: this.meetingInfo.callId,
          serverIdx: item.serverIdx,
        });
        let lod2 = await this.updateCallLegIdStatus(
          item.callLegId,
          item.remoteParty,
          item.serverIdx,
        );
        this.loadingDialog.dialog = false;
      } else {
        // 새하 제어
        let type = 1; // (CAM: 1, MIC: 2, SPK: 3)
        let value = item.rxVideoMute ? 1 : 0; // (STOP: 0, START: 1)

        this.loadingDialog.dialog = true;
        await this.updateParticipantDevice(
          this.meetingInfo._id,
          item.userId,
          type,
          value,
        );
        setTimeout(async () => {
          await this.refreshParticipantsStatus(item.roomCode, item.userId);
          this.loading = false;
        }, 500);
      }
    },
    async updateParticipantDevice(meetingKey, userId, type, value) {
      return new Promise(async (resolve, reject) => {
        // 새하 참석자 장치 상태 변경
        try {
          let params = {
            meetingKey,
            userId,
            type,
            value,
            isMCU: true,
          };

          let response = (
            await this.$http.post(
              `/api/v1/meetings/pcmobile/participants/control/`,
              params,
            )
          ).data;

          resolve(response);
        } catch (error) {
          console.log(error);
        }
      });
    },

    async refreshParticipantsStatus(meetingKey, userId) {
      // 새하 참석자 상태 새로고침
      // await setTimeout(async () => {
      try {
        console.log('refreshParticipantsStatus called..', { meetingKey });
        this.loadingDialog.dialog = true;
        let responseStatus = (
          await this.$http.get(
            `/api/v1/meetings/pcmobile/participants/${userId}`,
            {
              params: { meetingKey, isMCU: true },
            },
          )
        ).data;

        let index = this.attendeeList.findIndex(
          (item) => item.userId === userId,
        );

        if (index >= 0) {
          let meetUser = responseStatus.data.meetUser;
          console.log({ meetUser });
          let newData = Object.assign({}, this.attendeeList[index]);

          if (meetUser.micStatusCd === 1) {
            newData['rxAudioMute'] = false;
          } else {
            newData['rxAudioMute'] = true;
          }

          if (meetUser.camStatusCd === 1) {
            newData['rxVideoMute'] = false;
          } else {
            newData['rxVideoMute'] = true;
          }

          this.attendeeList[index] = newData;
        }
        this.loadingDialog.dialog = false;
        // this.loading = false;

        console.log('refreshParticipantsStatus called.. after', {
          attendeeList: this.attendeeList,
        });
      } catch (error) {
        console.log(error);
        this.loadingDialog.dialog = false;
        this.loading = false;
      }
      // }, 2000);
    },
    async connectUser(remoteParty, name, item) {
      // 사용자 이면, 연결은 불가능 하기 때문에 alert누르고, 쪽지 발송 API 호출
      if (item.type !== 'codec') {
        alert('선택한 사용자에게 미팅 참여 안내 쪽지가 발송 됩니다.');
        console.log(`connectUser Info`, item);
        await this.$http
          .post(`/api/v1/meetings/send/join/message`, {
            meetingId: this.meetingInfo._id,
            empNum: item.userId,
          })
          .then((response) => {
            console.log(response.data);
          })
          .catch((error) => {
            console.log(error);
          });
        return;
      }

      this.loading = true;
      item['connLoading'] = true;
      let params = {
        remoteParty: remoteParty,
      };
      // if (name) {
      //   params['nameLabelOverride'] = name;
      // }

      await this.$http
        .post(`/api/v1/meetings/connectUser/${this.meetingInfo.callId}`, params)
        .then(async (response) => {
          if (response.data) {
            await this.updateCallLegIdStatus(response.data, remoteParty, 1);
          } else {
            // Loading 상태 변경
            let index = this.attendeeList.findIndex(
              (item) => item.remoteParty === remoteParty,
            );
            if (index >= 0) {
              this.attendeeList[index]['connLoading'] = false;
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async updateCallLegIdStatus(callLegId, remoteParty, serverIdx) {
      // await setTimeout(async () => {
      return new Promise(async (resolve, reject) => {
        await this.$http
          .get(`/api/v1/meetings/getNowStatusDetail/${callLegId}`, {
            params: { serverIdx: serverIdx, callId: this.meetingInfo.callId },
          })
          .then((responseStatus) => {
            let index = this.attendeeList.findIndex(
              (item) => item.remoteParty === remoteParty,
            );
            if (responseStatus.data) {
              if (
                index >= 0 &&
                (responseStatus.data.callLeg.status.state === 'connected' ||
                  (responseStatus.data.callLeg.status.state === 'initial' &&
                    remoteParty.split('@').length >= 1 &&
                    remoteParty.split('@')[1] === 'doosandi.webex.com'))
              ) {
                this.attendeeList[index].callLegId = callLegId;
                this.attendeeList[index].status = true;
                let confData = responseStatus.data.callLeg.configuration;
                this.attendeeList[index]['serverIdx'] = serverIdx;
                this.attendeeList[index]['rxAudioMute'] =
                  confData.rxAudioMute === 'true' ? true : false;
                this.attendeeList[index]['rxVideoMute'] =
                  confData.rxVideoMute === 'true' ? true : false;
                this.attendeeList[index]['presentationContributionAllowed'] =
                  confData.presentationContributionAllowed === 'true'
                    ? true
                    : false;
              }
            }
            // Loading 상태 변경
            if (index >= 0) {
              this.attendeeList[index]['connLoading'] = false;
            }
            this.loading = false;
            resolve(true);
          })
          .catch((error) => {
            console.log(error);
            this.loadingDialog.dialog = false;
            this.loading = false;
            resolve(false);
          });
      });
      // }, 2000);
    },
    async disConnectUser(callLegId, serverIdx, type, item) {
      this.loading = true;
      if (item.type === 'codec') {
        // CMS
        let index = this.attendeeList.findIndex(
          (item) => item.callLegId === callLegId,
        );
        await this.$http
          .post(`/api/v1/meetings/disConnectUser/${callLegId}`, {
            params: JSON.stringify(this.attendeeList[index]),
          })
          .then((response) => {
            if (index >= 0) {
              this.attendeeList[index].callLegId = null;
              this.attendeeList[index].status = false;
              this.attendeeList[index].connLoading = false;
            }
            this.loading = false;
            console.log('disConnectUser called..', {
              attendeeList: this.attendeeList,
            });
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        // 새하
        console.log('disConnectUser called.. 새하', this.attendeeList, item);

        let index = this.attendeeList.findIndex(
          (a) => a.userId === item.userId,
        );
        console.log({ index });
        let params = {
          meetingKey: this.meetingInfo._id,
          userId: item.userId,
          isMCU: true,
        };

        await this.$http
          .post(`/api/v1/meetings/pcmobile/participants/leave/`, params)
          .then((response) => {
            console.log({ response });
            this.attendeeList[index].status = false;
            this.attendeeList[index].connLoading = false;
            this.loading = false;
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    async sendMessage() {
      let params = {
        messageText: this.messageText,
        messageDuration: this.selectedMessageTime,
      };
      await this.$http
        .post(
          `/api/v1/meetings/send/message/${this.meetingInfo.callId}`,
          params,
        )
        .then((response) => {
          Util.snackBarOpen('공지사항 설정 완료.', 'green');
        })
        .catch((error) => {
          Util.snackBarOpen('공지사항 설정 에러.', 'red');
          console.log(error);
        });
    },
    async deleteMessage() {
      let params = {
        messageText: this.messageText,
        messageDuration: this.selectedMessageTime,
      };
      await this.$http
        .post(
          `/api/v1/meetings/delete/message/${this.meetingInfo.callId}`,
          params,
        )
        .then((response) => {
          Util.snackBarOpen('공지사항 설정 완료.', 'green');
        })
        .catch((error) => {
          Util.snackBarOpen('공지사항 설정 에러.', 'red');
          console.log(error);
        });
    },
    async setRecordStatus(value) {
      /**
       * value : true, false
       */
      let body = {
        recording: value,
        coSpaceId: this.meetingInfo.coSpaceId,
      };
      await this.$http
        .post(
          `/api/v1/meetings/setRecordStatus/${this.meetingInfo.callId}`,
          body,
        )
        .then((response) => {
          this.getCallStatus(this.meetingInfo.callId, this.meetingInfo._id);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async setStreamingStatus(isLiveStreaming) {
      // 만약 사용자가 없는경우 스트리밍을 할 수 없습니다. ( 메시지 표시 )
      if (
        isLiveStreaming === true &&
        this.attendeeList.filter((item) => item.status === true).length <= 0
      ) {
        Util.snackBarOpen('참여자가 없으면 스트리밍을 할 수 없습니다.', 'pink');
        return;
      }

      this.loadingDialog.dialog = true;
      let body = {
        streaming: isLiveStreaming,
        callId: this.meetingInfo.callId,
        coSpaceId: this.meetingInfo.coSpaceId,
      };
      await this.$http
        .post(`/api/v1/meetings/liveStream`, body)
        .then((response) => {
          let data = response.data;
          if (data.allUse) {
            Util.snackBarOpen(
              '모든 Live streaming 주소가 사용중입니다.',
              'pink',
            );
            this.isStreaming = !isLiveStreaming;
          } else {
            this.isStreaming = isLiveStreaming;
          }
          this.loadingDialog.dialog = false;
        })
        .catch((error) => {
          console.log(error);
          this.loadingDialog.dialog = false;
        });
    },
    async lockedCallClick() {
      if (this.call !== null) {
        this.loadingDialog.dialog = true;
        let body = {
          locked: this.call.call.locked === 'true' ? 'false' : 'true',
        };
        await this.$http
          .post(`/api/v1/meetings/locked/${this.meetingInfo.callId}`, body)
          .then((response) => {
            this.getCallStatus(this.meetingInfo.callId, this.meetingInfo._id);
            this.loadingDialog.dialog = false;
          })
          .catch((error) => {
            console.log(error);
            this.loadingDialog.dialog = false;
          });
      }
    },
    async fixLayoutClick() {
      console.log(`fixLayout`, 'open Laytout 고정 기능 팝업');
      this.fixLayout.dialog = true;
      // fixLayout
    },
    async applyLayoutAll() {
      this.warning.title = '전체 레이아웃';
      this.warning.content = `레이아웃을 변경 하시겠습니까?`;
      this.warning.confirmText = '확인';
      this.warning.type = 'layoutAll';
      this.warning.dialog = true;
    },
    async sendMessageConfirm() {
      this.warning.title = '공지사항 전달';
      this.warning.content = `공지를 전달하시겠습니까?`;
      this.warning.confirmText = '확인';
      this.warning.type = 'sendMessage';
      this.warning.dialog = true;
    },
    async layoutAllChange() {
      // all 은 layout
      await this.updateUserStatusAll({ layout: this.layoutAll });
    },
    async additionalInvite() {
      this.loadingDialog.dialog = true;

      await this.getRoomTree();
      // 화상회의인 경우 Device List 가져오기
      // await this.getPersonalDevice(); // 개인 단말 추가하는것 삭제하면서 주석처리
      // Get OriganizationTree Data
      // await this.getOrganizationTree();
      // Get People Data
      // await this.getPeopleData();

      this.addRoom.dialog = true;
      this.loadingDialog.dialog = false;
    },
    async getRoomTree() {
      // startTime, EndTime 계산
      let start = this.meetingInfo.startDtime; // moment.tz(this.meetingInfo.startDtime, this.meetingInfo.timeZone);
      let end = this.meetingInfo.endDtime; // moment.tz(this.meetingInfo.endDtime, this.meetingInfo.timeZone);
      // let now = moment.tz(moment().format('YYYY-MM-DD HH:mm'), this.meetingInfo.timeZone);
      let meetingType = this.meetingInfo.type === 0 ? 'room' : 'video';

      let params = { meetingType: meetingType, start: start, end: end };
      if (this.editMode) {
        params['_id'] = this.routerParams._id;
      }

      if (this.meetingInfo.type === 0) {
        params['type'] = 'room';
      } else {
        params['type'] = 'video';
      }

      if (this.meetingInfo.roomIds) {
        params['meetingId'] = this.meetingInfo._id;
      }

      params['email'] = this.$store.state.user.email;

      await this.$http
        .get('/api/v1/rooms/getRoomTreeAll', { params: params })
        .then((response) => {
          this.addRoom.roomItems = response.data;
          // this.roomItems = response.data;
          // console.log(this.roomItems);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async getPersonalDevice() {
      let params = { meetingId: this.meetingInfo._id };

      await this.$http
        .get('/api/v1/devices/getPersonalDevice', { params: params })
        .then((response) => {
          this.addRoom.personalItems = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async refreshAll() {
      this.loadingDialog.dialog = true;
      this.initAttendees(this.meetingInfo);
      this.getCoSpaceInfo(this.meetingInfo.callId, this.meetingInfo._id);
      await Promise.all([
        this.getControlDevice(this.meetingInfo._id),
        this.getNowStatus(this.meetingInfo.callId),
        this.getNowStatusFromSaeha(this.meetingInfo._id),
      ]);
      this.attendeeListSort();
      this.loadingDialog.dialog = false;
    },
    async dialAll() {
      await await this.refreshAll();
      // this.loadingDialog.dialog = true;
      // 현재 미참여 인 사람한테 모두 Call
      this.attendeeList
        .filter((item) => item.status === false)
        .forEach((item) => {
          // 한명씩 call 보냄()
          this.connectUser(item.remoteParty, item.name);
        });
      // this.loadingDialog.dialog = false;
    },
    async muteAll() {
      this.loadingDialog.dialog = true;
      this.loading = true;
      // CMS 음소거 호출
      let callLegIds = this.attendeeList
        .filter((attendee) => {
          return attendee.callLegId !== null;
        })
        .map((attendee) => {
          return attendee.callLegId;
        });

      callLegIds.forEach(async (callLegId, index) => {
        let selectedCallLeg = this.attendeeList.find(
          (a) => a.callLegId === callLegId,
        );
        let serverIdx = selectedCallLeg ? selectedCallLeg.serverIdx : 1;

        console.log('forEach called..', { callLegId, serverIdx, index });

        await this.updateUserStatus(callLegId, {
          rxAudioMute: false,
          callId: this.meetingInfo.callId,
          serverIdx,
        });
      });

      // 새하 음소거
      let meetingKey = this.meetingInfo._id;
      let value = 0;
      let type = 2;
      await this.updateParticipantDevice(meetingKey, null, type, value);
      await this.refreshAll();

      this.loadingDialog.dialog = false;
      this.loading = false;
    },
    async unMuteAll() {
      this.loadingDialog.dialog = true;
      await this.updateUserStatusAll({ rxAudioMute: false });
      this.loadingDialog.dialog = false;
    },
    async finishMeeting() {
      // 경고 팝업 띄우기
      this.warning.title = '회의 종료';
      this.warning.content = `회의를 종료 하시겠습니까?`;
      this.warning.confirmText = '확인';
      this.warning.type = 'finishMeeting';
      this.warning.dialog = true;
    },
    async roomSave(selectedRooms) {
      console.log('roomSave called..', { selectedRooms });

      let deviceIds = selectedRooms.map((selectedRoom) => {
        return selectedRoom._id;
      });

      console.log({ deviceIds });

      let params = {
        deviceIds,
      };

      try {
        let response = (
          await this.$http.post(
            `/api/v1/meetings/${this.meetingInfo._id}/deviceIds`,
            params,
          )
        ).data;
        console.log('attendeeSave called.. ', { response });

        this.meetingInfo = response;

        this.initAttendees(this.meetingInfo);
        // this.getCoSpaceInfo(this.meetingInfo.callId, this.meetingInfo._id);
        await Promise.all([
          this.getControlDevice(this.meetingInfo._id),
          this.getCallStatus(this.meetingInfo.callId, this.meetingInfo._id),
          this.getNowStatus(this.meetingInfo.callId),
          this.getNowStatusFromSaeha(this.meetingInfo._id),
        ]);
        this.attendeeListSort();
        this.meetingConferenceDialog.dialog = false;
      } catch (err) {
        console.log(err);
      }
    },
    async closeWarningDialog(ret) {
      console.log(`closeWarningDialog`, ret);
      if (ret === 'ok') {
        if (this.warning.type === 'finishMeeting') {
          this.warning.dialog = false;
          // 종료
          await this.$http
            .post(`/api/v1/meetings/finishMeeting/${this.meetingInfo._id}`, {
              isMCU: true,
            })
            .then((response) => {
              if (response.data.success === true) {
                this.closeDialog('control');
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else if (this.warning.type === 'layoutAll') {
          this.layoutAllChange();
          this.warning.dialog = false;
        } else if (this.warning.type === 'sendMessage') {
          this.sendMessage();
          this.warning.dialog = false;
        }
      } else {
        this.warning.dialog = false;
      }
    },
    closeRoomDialog() {
      this.addRoom.dialog = false;
    },
    closeLayoutDialog() {
      this.fixLayout.dialog = false;
    },
    async getOrganizationTree() {
      let params = {
        meetingId: this.meetingInfo._id,
      };
      await this.$http
        .get('/api/v1/organizations/trees', { params: params })
        .then((response) => {
          this.addAttendee.organizationItems = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async getPeopleData() {
      let params = {
        meetingId: this.meetingInfo._id,
      };
      await this.$http
        .get('/api/v1/organizations/filtered', { params: params })
        .then((response) => {
          this.addAttendee.people = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async attendeeDetailClick(item) {
      this.loadingDialog.dialog = true;
      // get Attendee Detail Info;
      await this.$http
        .get(`/api/v1/meetings/getNowStatusDetail/${item.callLegId}`, {
          params: {
            serverIdx: item.serverIdx,
            callId: this.meetingInfo.callId,
          },
        })
        .then((response) => {
          this.attendeeDetail.attendeeInfo = item;
          this.attendeeDetail.attendeeDetailInfo = response.data.callLeg;
          this.attendeeDetail.dialog = true;
          this.loadingDialog.dialog = false;
        })
        .catch((error) => {
          this.loadingDialog.dialog = false;
          console.log(error);
        });
    },
    async layoutChange(callLegId, layout) {
      // serverIdx 찾기
      let selectedCallLeg = this.attendeeList.find(
        (a) => a.callLegId === callLegId,
      );
      let serverIdx = selectedCallLeg ? selectedCallLeg.serverIdx : 1;
      // 개별 변경은 chosenLayout
      await this.updateUserStatus(callLegId, {
        chosenLayout: layout,
        callId: this.meetingInfo.callId,
        serverIdx: serverIdx,
      });
    },
    closeDetailDialog() {
      this.attendeeDetail.dialog = false;
    },
    async refreshDetailData(callLegId) {
      // serverIdx 찾기
      let selectedCallLeg = this.attendeeList.find(
        (a) => a.callLegId === callLegId,
      );
      let serverIdx = selectedCallLeg ? selectedCallLeg.serverIdx : 1;
      await this.$http
        .get(`/api/v1/meetings/getNowStatusDetail/${callLegId}`, {
          params: { serverIdx: serverIdx, callId: this.meetingInfo.callId },
        })
        .then((response) => {
          this.attendeeDetail.attendeeDetailInfo = response.data.callLeg;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    popupClose() {
      this.loadingDialog.dialog = false;
      this.closeDialog('control');
    },
    getTypeString(participantType, type) {
      if (participantType === 'skype') {
        // Skype 참여 인 경우
        return 'PC/Mobile';
      } else if (participantType === 'webex' || type === 'webex') {
        // Webex 참여 인 경우
        return this.$t('page.statistics.history.webex');
      } else if (participantType === 'webrtc') {
        // WebRTC 참여 인 경우
        return 'WebRTC';
      } else if (participantType === 'codec') {
        // Codec 참여 인 경우
        return this.$t('page.statistics.history.codec');
      } else if (!participantType && type === 'device') {
        // codec인데 참여 안 한경우
        return this.$t('page.statistics.history.codec');
      } else {
        // 초대자인데 참여 안 한경우
        return '';
      }
    },
    openMeetingLayoutDialog() {
      /* 레이아웃 설정 */
      // 참석자 목록 설정
      this.meetingLayoutDialog.attendees = Object.assign(
        [],
        this.meetingInfo.attendees,
      );
      if (this.meetingInfo.conferenceRooms.length >= 1) {
        // 영상회의실 추가
        let codecList = this.meetingInfo.conferenceRooms.map((c) => {
          c['isDevice'] = true;
          c['name'] = c.deviceName;
          return c;
        });
        this.meetingLayoutDialog.attendees =
          this.meetingLayoutDialog.attendees.concat(codecList);
      }
      // 기존 설정 된 값 Setting
      if (
        this.meetingInfo.layout &&
        this.meetingInfo.layout.isLayout === true
      ) {
        this.meetingLayoutDialog.fixSeatList =
          this.meetingInfo.layout.fixSeatList;
        this.meetingLayoutDialog.selectedLayoutCode =
          this.meetingInfo.layout.selectedLayoutCode;
      }
      this.meetingLayoutDialog.dialog = true;
    },
    closeMeetingLayoutDialog() {
      this.meetingLayoutDialog.dialog = false;
    },
    async selectedFixSeatList(
      selectedLayoutCode,
      selectedLayoutImage,
      fixSeatList,
    ) {
      /* @emit function */
      console.log(
        '## selectedFixSeatList ##',
        selectedLayoutCode,
        selectedLayoutImage,
        fixSeatList,
      );

      // Backend 호출 (DB 저장 및 레이아웃 설정, 고정자리 설정)
      await this.$http.post(
        `/api/v1/meetings/layoutOption/${this.meetingInfo._id}`,
        {
          layoutCode: selectedLayoutCode,
          fixSeatList: fixSeatList,
          layoutImage: selectedLayoutImage,
        },
      );
      this.getMeetingInfo();
      this.closeMeetingLayoutDialog();
    },
  },
};
</script>
<style scoped>
/* MeetingControlDialog */
.title-wrap {
  float: left;
  font-weight: 300;
  font-size: 15px;
  margin-right: 30px;
  margin-left: 10px;
}
.contents-wrap {
  float: left;
  font-weight: 100;
  font-size: 15px;
}

.title-wrap div {
  height: 25px;
}

.contents-wrap div {
  height: 25px;
}

.v-card {
  box-shadow: none;
}

.all-control-div {
  display: flex;
  justify-content: space-between;
}

.meeting-control-btn {
  width: 100px;
  height: 32px;
  border-radius: 5px;
  font-weight: 300;
  text-align: center;
  line-height: 30px;
  background: #6264a7;
  cursor: pointer;
  color: white;
  margin-right: 10px;
}

.meeting-control-btn:hover {
  opacity: 0.8;
}

.header-text-popup {
  background: white;
}

.v-card__text {
  padding-top: 5px;
}

.history-info-btn {
  width: 100px;
  height: 32px;
  border-radius: 7px;
  font-weight: 500;
  font-size: 13px;
  text-align: center;
  line-height: 32px;
  background: white;
  border: 1px solid #f46600;
  cursor: pointer;
  color: #f46600;
}

.history-info-btn:hover {
  background-color: #f46600;
  color: white;
}

.history-info-btn-active {
  /* background-color: #464775; */
  background-color: #f46600;
  color: white;
}

input {
  border: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/MeetingControlDialog.vue